import * as React from 'react';
import { FlatList, Platform, Text, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { Divider } from 'react-native-paper';
import { CustomScrollView } from '../components/CustomScrollView';
import { CustomButton } from '../components/CustomButton';
import { TextInput } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";
import { GooglePlacesAutocomplete } from 'react-native-google-places-autocomplete';
import Constants from 'expo-constants';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingBottom: 10,
  },
  labelPadLeft: {
    fontSize: 14,
    fontWeight: "bold",
    paddingLeft: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexShrink: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
  },
  listItemStyle: {
    paddingLeft: 5,
  }
});

export function SuggestLocation({ navigation }) {
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);

  const autocompleteRef = React.useRef();

  const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      email: "",
      address: "",
      products: "",
    }
  });

  async function onSubmit(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "SuggestLocation.onSubmit",
        "/find_humane/api/contact",
        "POST",
        {
          email: data.email,
          data: data.products + " at " + data.address,
          subject: "Suggested location",
        }
      );

      showTemporarySnack("Thanks! We'll review soon.");

      reset();
      autocompleteRef.current.setAddressText("");

      navigation.pop();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "SuggestLocation.onSubmit");
    } finally {
      hideSpinner();
    }

  }

  async function onValidationErrors(errors) {
    showTemporarySnack("There are some errors in the form");
  }

  return (
    <View style={styles.container}>
      <FlatList
        keyboardShouldPersistTaps="handled"
        data={[]}
        ListHeaderComponent={(
          <>
            <Text selectable={true} style={styles.normal}>We don't charge for listing locations as long as they offer some products certified with Animal Welfare Approved, Certified Humane, or Animal Welfare Certified. If they don't, we suggest telling the location to consider adding products listed on Find Humane:</Text>
            <Divider style={AppConstants.STYLES.marginVertical10} />

            {errors.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Email is required.</Text>}
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Your email (in case of questions)"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNone}
                  mode="outlined"
                  dense={true}
                  returnKeyType="next"
                  onBlur={onBlur}
                  autoComplete="email"
                  keyboardType="email-address"
                  textContentType="emailAddress"
                />
              )}
              name="email"
            />

            {errors.address && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Location is required.</Text>}
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ minHeight: 75, }}>
                  <GooglePlacesAutocomplete
                    placeholder="Location"
                    minLength={2}
                    debounce={200}
                    autoFocus={false}
                    ref={autocompleteRef}
                    predefinedPlaces={[]}
                    //listViewDisplayed="auto"
                    fetchDetails={true}
                    styles={{
                      container: {
                        //margin: 10,
                      },
                      description: {
                        fontWeight: "bold",
                        //color: "black",
                      },
                      listView: {
                      },
                      predefinedPlacesDescription: {
                        //color: "black",
                      },
                      textInput: {
                        backgroundColor: "#f6f6f6",
                      },
                      textInputContainer: {
                        width: "100%",
                        backgroundColor: "#f6f6f6",
                        borderWidth: 1,
                        borderColor: "#717171",
                        //borderRadius: 5,
                      },
                      row: {
                        //backgroundColor: "transparent",
                      }
                    }}
                    textInputProps={{ placeholderTextColor: "#717171" }}
                    query={{
                      key: Constants.expoConfig.extra.googleNoRestrictionsKey,
                      language: "en",
                      //types: "(cities)",
                    }}
                    onPress={(data, details) => {

                      /*
                      data:
                        description: "Whole Foods Market, North Lamar Boulevard, Austin, TX, USA"
                        ​place_id: "ChIJf5QJFBK1RIYRjjfxZz9Z0O0"
                        structured_formatting:
                          main_text: "Whole Foods Market"
                          secondary_text: "North Lamar Boulevard, Austin, TX, USA"

                      details:
                        formatted_address: "525 N Lamar Blvd, Austin, TX 78703, USA"
                        geometry:
                          location:
                            lat: 30.2706339
                            lng: -97.753587
                      */

                      let result = details.formatted_address;

                      if (data.structured_formatting && data.structured_formatting.main_text) {
                        result = data.structured_formatting.main_text + ", " + result;
                      }

                      if (details.geometry && details.geometry.location) {
                        result += "; " + details.geometry.location.lat + "," + details.geometry.location.lng;
                      }

                      onChange(result);
                    }}
                    GooglePlacesDetailsQuery={{
                      fields: "formatted_address,geometry",
                    }}
                    enablePoweredByContainer={false}
                    timeout={10000} //ms
                    onFail={(error) => {
                      showTemporarySnack("Failed lookup: " + error);
                    }}
                    onTimeout={(data) => {
                      showTemporarySnack("Timed out. Check your internet connection.");
                    }}
                    requestUrl={{
                      useOnPlatform: 'web',
                      url: AppUtilities.getRootUri() + 'proxy/https://maps.googleapis.com/maps/api',
                    }}
                  />
                </View>
              )}
              name="address"
            />
          </>
        )}
        ListFooterComponent={(
          <>
            <Divider style={AppConstants.STYLES.marginBottom10} />

            {errors.products && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Humane products required.</Text>}
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Certified animal-based products"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNoneMinHeight}
                  mode="outlined"
                  dense={true}
                  returnKeyType="next"
                  onBlur={onBlur}
                  multiline={true}
                  numberOfLines={5}
                  textAlignVertical="top"
                />
              )}
              name="products"
            />

            <CustomButton
              onPress={handleSubmit(onSubmit, onValidationErrors)}
              style={AppConstants.STYLES.paddingVertical10}
            >Submit</CustomButton>
          </>
        )}
      />
    </View>
  );
}
